import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { SupplierApi } from '../models';

const suppliersService = createApi({
  reducerPath: 'suppliersService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/suppliers`),
  tagTypes: ['Suppliers'],
  endpoints: (builder) => ({
    getSuppliers: builder.query<
      PaginatedResponse<SupplierApi>,
      { search?: string; paginated: PaginatedRequest }
    >({
      query: ({ search, paginated }) => {
        const params: any = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.name = search.trim();
        }

        return {
          url: '',
          params,
        };
      },
      providesTags: ['Suppliers'],
    }),
    createSupplier: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Suppliers'],
    }),
    updateSupplier: builder.mutation({
      query: ({ supplierId, body }) => ({
        url: `/${supplierId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Suppliers'],
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
} = suppliersService;

export default suppliersService; 